import { gql } from '@apollo/client';

export const HANDLE_BAG_MERGE_EVENT = gql`
  mutation HandleBagMergeEvent($input: BagMergeInput!) {
    handleBagMergeEvent(input: $input) {
      success
      mergeTaskId
      totalOrderCount
      totalBagCount
      targetBagNumber
      bagBreakdown {
        bagId
        bagNumber
        orderCount
        isTarget
      }
    }
  }
`;

export interface BagMergeInput {
  sourceBagIds: number[];
  targetBagId: number;
}

export interface BagMergeBagBreakdownType {
  bagId: number;
  bagNumber: string;
  orderCount: number;
  isTarget: boolean;
}

export interface BagMergeResultType {
  success: boolean;
  mergeTaskId: number;
  totalOrderCount: number;
  totalBagCount: number;
  targetBagNumber: string;
  bagBreakdown: BagMergeBagBreakdownType[];
}

export interface HandleBagMergeEventResponse {
  handleBagMergeEvent: BagMergeResultType;
}

export interface HandleBagMergeEventVariables {
  input: BagMergeInput;
}
